import { render, staticRenderFns } from "./info_company.vue?vue&type=template&id=48f084ca&scoped=true&"
import script from "./info_company.vue?vue&type=script&lang=js&"
export * from "./info_company.vue?vue&type=script&lang=js&"
import style0 from "./info_company.vue?vue&type=style&index=0&id=48f084ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f084ca",
  null
  
)

export default component.exports